module.exports = __webpack_public_path__ + "static/media/NineBottomBackground.54c4cda9.svg";